import { useMemo } from 'react'
import ai from '../../../api/ai/hooks'
import { realEstateDescriptionFields } from '../../../common/forms/generalRealEstate/fields'
import useLocaleOptions from '../../../Components/Hooks/useLocaleOptions'

export const usePropertyDescriptionFormSelectOptions = (activeTab: string) => {
    const { data: aiFormValues, isPending } = ai.FormValues.useQuery(undefined, undefined, {
        enabled: activeTab === 'description',
    })
    const localeOptions = useLocaleOptions()

    const selectOptions = useMemo(
        () => ({
            [realEstateDescriptionFields.PROPERTY_DESCRIPTION_EMPHASIS]: aiFormValues?.emphasis,
            [realEstateDescriptionFields.PROPERTY_DESCRIPTION_LANG]: localeOptions,
        }),
        [aiFormValues?.emphasis, localeOptions]
    )

    return { selectOptions, isPending: activeTab === 'description' && isPending }
}
